<template>
  <div>
    <div class="ceiling">
      <home-top></home-top>
    </div>
    <!-- <div class="h-top"></div> -->
    <div class="content w-1400">
      <div class="bread-crumb">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/project-transaction' }">来料加工</el-breadcrumb-item>
          <el-breadcrumb-item>工厂资源</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="title">工厂资源</div>
      <div class="content-body" v-loading="loading">
        <!--        左侧详情-->
        <div class="body-left">
          <div class="top-tag">
            <el-tag v-if="detailInfo.type == 1" effect="dark" type="success" color="#6AC9A9">工厂方</el-tag>
            <el-tag v-if="detailInfo.type == 2" effect="dark" type="success" color="#6AC9A9">需求方</el-tag>
            <el-tag effect="plain" type="info">项目编号：{{ detailInfo.id }}</el-tag>
          </div>
          <div class="body-content-title">
            {{ detailInfo.title }}
          </div>
          <div class="need-info">资源描述:
            <span class="body-content-desc">{{ detailInfo.desc }}</span>
          </div>
          <div class="body-content">
            <table border="1" class="custom-table">
              <tr>
                <td>所在园区名称</td>
                <td>{{ detailInfo.park_name }}</td>
                <td>园区等级</td>
                <td>{{ detailInfo.park_level == 1 ? "国家级" : "省级" }}</td>
              </tr>
              <tr>
                <td>占地面积</td>
                <td>{{ detailInfo.space }}</td>
                <td>生产所在地</td>
                <td v-if="detailInfo.address">
                  {{ detailInfo.address.province }}{{
                    detailInfo.address.city
                  }}{{ detailInfo.address.area }}
                </td>
              </tr>
              <tr>
                <td>工人规模</td>
                <td>{{ detailInfo.worker_size }}</td>
                <td>工作时间</td>
                <td v-if="detailInfo.work_type == 1">无倒班</td>
                <td v-if="detailInfo.work_type == 2">两班倒</td>
                <td v-if="detailInfo.work_type == 3">三班倒</td>
              </tr>
              <tr>
                <td>小实验室</td>
                <td>{{ detailInfo.small_libaray == 1 ? "有" : "无" }}</td>
                <td>处理废水能力</td>
                <td>
                  {{ detailInfo.feishui }}
                </td>
              </tr>
              <tr>
                <td>处理废气能力</td>
                <td>
                  {{ detailInfo.feiqi }}
                </td>
                <td>处理废固能力</td>
                <td>
                  {{ detailInfo.feigu }}
                </td>
              </tr>
              <tr>
                <td>反应温度</td>
                <td>{{ detailInfo.temperature }}</td>
                <td>发布时间</td>
                <td>{{ detailInfo.created_at }}</td>
              </tr>

              <!-- 第6行 -->
              <tr>
                <td>特色工艺</td>
                <td colspan="4">
                  {{ detailInfo.special_machining || "--" }}
                </td>
              </tr>

              <!-- 第7行 -->
              <tr>
                <td>设备类型及数量</td>
                <td colspan="3">
                  <span v-for="(item, index) in detailInfo.equipment" :key="index">{{ item.equip }}{{
                      item.number
                    }}{{
                      index == detailInfo.equipment.length - 1 ? "" : ","
                    }}</span>
                </td>
              </tr>
              <tr>
                <td>详情</td>
                <td colspan="3">{{ detailInfo.detail || "--" }}</td>
              </tr>
              <tr>
                <td>官网</td>
                <td colspan="3">{{ detailInfo.website || "--" }}</td>
              </tr>
            </table>
          </div>
          <div class="body-button-list">
            <gradient-button @hit="publishDemand" width="170px" height="40px"
                             background="#387DF6">发布供需
            </gradient-button>
            <gradient-button @hit="handleGetContact" width="216px" height="40px" background="#F3AD3E"
                             border="1px solid #F3AD3E">免费获取联系方式
            </gradient-button>
            <gradient-button @hit="handleGuarantee" width="170px" height="40px" background="#E9F1FE" color="#387DF6"
                             border="1px solid #336ED2">联系客服
            </gradient-button>
          </div>
          <div class="button-info">
            <div class="p-box">声明</div>
            <div class="desc-info">
              工厂资源信息由化联网平台注册用户自主发布，本平台为其提供免费线上展示服务。尽管所有信息均经过严格审核，但鉴于化学化工技术的复杂性和专业性，本平台无法完全保证技术类信息的真实性、可靠性及有效性。
            </div>
          </div>
        </div>
        <!--        右侧表格-->
        <div class="body-right">
          <div class="right-title">最新供需</div>
          <div class="right-content">
            <information v-for="(item, index) in informationList" :key="index" :data="item"></information>
          </div>
        </div>
      </div>
    </div>
    <!-- 联系客服 -->
    <el-dialog :close-on-press-escape="false" :close-on-click-modal="false" :modal-append-to-body="false"
               :title="dialogTitle" :modal="false" top="20vh" :visible.sync="dialogVisible" width="30%"
               :before-close="handleClose">
      <span class="dialog-content" @click="copyText(dialogContent)">{{ dialogContent }} <i
          class="el-icon-copy-document"></i>
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
      </span>
    </el-dialog>
    <home-footer></home-footer>
  </div>
</template>
<script>
import HomeTop from "../../../components/public/home-top.vue";
import Navicat from "../../../components/navicat/navicat.vue";
import Information from "../../../components/goods/information.vue";
import {proces_detail, proces_list} from "@/api/modules/home";
import GradientButton from '../../../components/button/gradient-button.vue';
import HomeFooter from "../../../components/public/home-footer.vue";
import {getMyCustomerService} from "../../../api";

export default {
  name: "demand",
  components: {HomeFooter, Navicat, HomeTop, Information, GradientButton},
  data() {
    return {
      id: this.$route.query.id,
      informationList: [],
      detailInfo: {},
      listInfo: [],
      dialogVisible: false,
      dialogTitle: "",
      dialogContent: "",
      loading: false,
      kefu: ''
    };
  },
  computed: {
    configInfo() {
      return this.$store.state.config.config;
    },
  },
  watch: {
    '$route.query.id': {
      handler(newVal) {
        this.id = newVal;
        this.getDetail();
      },
      immediate: true,
    },
  },
  mounted() {
    this.getList();
    this.getDetail()
  },
  methods: {
    // 关闭弹窗
    handleClose() {
      this.dialogVisible = false;
    },
    // 联系客服
    handleGuarantee() {
      this.dialogVisible = true;
      this.dialogTitle = "联系客服";

      this.dialogContent = this.kefu;
    },
    // 免费获取联系方式
    handleGetContact() {
      this.dialogVisible = true;
      this.dialogTitle = "免费获取联系方式";

      this.dialogContent = this.detailInfo.phone;
    },
    // 发布供需
    publishDemand() {
      this.$router.push({
        path: "/user/user-center",
      });
    },
    // 获取详情
    getDetail() {
      this.loading = true;
      proces_detail(this.id).then((res) => {
        this.detailInfo = res.data.data;
        this.loading = false;
        if (this.detailInfo.three_wastes) {
          this.detailInfo.feiqi = this.detailInfo.three_wastes.tag.enable == 1 ? (this.detailInfo.three_wastes.tag.number || "--" + "/" + (this.detailInfo.three_wastes.tag.price || "--")) : '无'
          this.detailInfo.feigu = this.detailInfo.three_wastes.solid.enable == 1 ? (this.detailInfo.three_wastes.solid.number || "--" + "/" + (this.detailInfo.three_wastes.solid.price || "--")) : '无'
          this.detailInfo.feishui = this.detailInfo.three_wastes.water.enable == 1 ? (this.detailInfo.three_wastes.water.number || "--" + "/" + (this.detailInfo.three_wastes.water.price || "--")) : '无'
        } else {
          this.detailInfo.feiqi = '无'
          this.detailInfo.feigu = '无'
          this.detailInfo.feishui = '无'
        }
        if (this.detailInfo.special_machining) {
          this.detailInfo.special_machining = this.detailInfo.special_machining.join("、")
        }
        getMyCustomerService().then(res => {
          this.kefu = res.data.data.kefu.mobile
        })

      });
    },
    copyText(text) {
      this.$utils.copyText(text, this);
    },

    // 获取最新供需
    getList() {
      proces_list(1, {
        page: 1,
        limit: 4,
      }).then((res) => {
        this.informationList = res.data.data.data;
      });
    },
  },
};
</script>
<style scoped lang="scss">
.dialog-content {
  display: block;
  font-size: 20px;
  text-align: center;
}

.h-top {
  // height: 142px;
  height: 120px;
}

.content {
  padding-bottom: 40px;

  .bread-crumb {
    margin: 20px 0;
  }

  .title {
    font-weight: 800;
    font-size: var(--font-size-default-big);
    color: #00112b;
    padding-bottom: 20px;
    // line-height: 93px;
  }

  .content-body {
    display: flex;
    justify-content: space-between;

    .body-right {
      padding: 0 20px;
      box-sizing: border-box;
      width: 370px;
      height: 1074px;
      background: #ffffff;

      .right-title {
        font-weight: 800;
        line-height: 73px;
        font-size: var(--font-size-default-20);
        color: #00112b;
      }

      .right-content {
        display: flex;
        flex-direction: column;
        gap: 20px;
      }
    }

    .body-left {
      box-sizing: border-box;
      width: 1010px;
      height: 1074px;
      background: #ffffff;
      padding: 32px 37px;

      .top-tag {
        display: flex;
        gap: 30px;
        align-items: center;
      }

      .body-content-title {
        font-weight: 800;
        font-size: var(--font-size-default-20);
        color: #00112b;
        padding: 20px 0 10px;
      }

      .need-info {
        font-weight: 400;
        font-size: 16px;
        color: #5F616C;
        line-height: 22px;
        margin-bottom: 20px;
      }

      .body-button-list {
        display: flex;
        justify-content: flex-end;
        gap: 20px;
        padding: 30px 0 30px;

        .button-blue {
          width: 214px;
          background: #387df6;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #336ed2;
          color: #ffffff;
          //line-height: 60px;
          text-align: center;
        }

        .info {
          width: 214px;
          height: 40px;
        }

        .button-yellow {
          width: 216px;
          background: #f3ad3e;
          border-radius: 4px 4px 4px 4px;
          border: 1px solid #dfa544;
          text-align: center;
          //line-height: 60px;
          color: #ffffff;
        }
      }

      .button-info {
        padding: 0 33px;
        height: 111px;
        background: #f9faff;

        .p-box {
          font-weight: bold;
          font-size: var(--font-size-default-16);
          color: #5f616c;
          padding-top: 10px;
          padding-bottom: 5px;
          //line-height: 41px;
        }

        .desc-info {
          font-weight: 400;
          font-size: 16px;
          color: #5f616c;
          line-height: 22px;
        }
      }

      .custom-table {
        width: 100%;
        border-collapse: collapse;
        /* 关键：合并边框 */
        border-color: #f3f3f3;

        /* 新增样式规则 */
        td:nth-child(1),
        td:nth-child(3) {
          width: 179px;
          height: 50px;
          background: #f9faff;
          text-align: right;
          padding-right: 43px;
          line-height: 50px;
          color: #5f616c;
        }

        td:nth-child(2),
        td:nth-child(4) {
          height: 50px;
          line-height: 50px;
          padding-left: 33px;
          border: 1px solid #f3f3f3;
          color: #00112b;
        }
      }
    }
  }
}
</style>
